import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { noop } from "utils/common";

import "./ToggleField.css";

export default function ToggleField(props){
	const {
		input: { value, onChange } = {},
		label,
		disabled,
		className,
		loading,
	} = props;

	const onClick = (e) => {
		e.stopPropagation();
		if(!disabled){
			onChange(!value);
		}
	};

	return (
		<div
			className={`toggle-wrapper ${className}`}
			onClick={onClick}
		>
			<div className="toggle-label">{label}</div>
			<div
				className={classNames({
					"toggle-field": true,
					"is-checked": !!value,
					"is-loading": !!loading,
				})}
			>
				<div className="slider"> </div>
			</div>
		</div>
	);
}

ToggleField.displayName = "ToggleField";

ToggleField.propTypes = {
	input: PropTypes.shape({
		value: PropTypes.any,
		onChange: PropTypes.func,
	}),
	label: PropTypes.string,
	disabled: PropTypes.bool,
	className: PropTypes.string,
};

ToggleField.defaultProps = {
	input: {
		onChange: noop,
	},
	label: "",
	disabled: false,
	className: "",
};
